import { useProfile } from '@hooks/getQueries';

export const useUserPermission = ({ entity, teamMembers }) => {
  const { data: userData, isLoading: userLoading } = useProfile();

  // DO NOT REMOVE THESE COMMENTS - NEED FOR DEBUGGING
  // useEffect(() => {
  //   if (!userLoading && userData) {
  //     console.log('Permission check:', {
  //       userEmail: userData?.email,
  //       entityOwnerId: entity?.owner_id,
  //       userId: userData?.id,
  //       teamMembers: teamMembers,
  //     });
  //   }
  // }, [userLoading, userData, entity, teamMembers]);

  // If any required data is still loading or missing, don't make a final permission decision
  if (userLoading || !userData || !entity) {
    return {
      canRunAnalysis: false,
      disabledRunAnalysis: false,
      isLoading: true,
    };
  }

  // Handle case when we have user data but no owner_id in entity
  if (!entity?.owner_id) {
    console.log('Missing entity owner_id - defaulting to no permission');
    return {
      canRunAnalysis: false,
      disabledRunAnalysis: true,
      isLoading: false,

      reason: 'missing_entity_owner',
    };
  }

  // Check ownership and permissions
  const isOwner = entity.owner_id === userData.id;
  const hasEditPermission =
    Array.isArray(teamMembers) &&
    teamMembers.some(
      (member) => member.user_email === userData.email && member.permissions?.includes('edit'),
    );

  const runAnalysisAllowed = isOwner || hasEditPermission;
  const canEdit = isOwner || hasEditPermission;

  return {
    canRunAnalysis: runAnalysisAllowed,
    disabledRunAnalysis: !runAnalysisAllowed,
    isLoading: false,
    reason: runAnalysisAllowed ? 'allowed' : isOwner ? 'not_owner' : 'no_edit_permission',
    canEdit: canEdit,
  };
};
